import { render, staticRenderFns } from "./landlord-settings.vue?vue&type=template&id=566eab6c&"
import script from "./landlord-settings.vue?vue&type=script&lang=js&"
export * from "./landlord-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports